<!--
 * @Author: cmchiu
 * @Date: 2022-04-26 08:43:53
 * @LastEditTime: 2023-07-03 13:26:39
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\News\news.vue
 * 
-->
<template>
    <div class="news">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation" v-for="item in newsType" :key="item.ST_ID">
                <button
                    :class="`nav-link ${item.ST_ID === currentType ? 'active' : ''} ${item.cssTag}`"
                    :id="`${item.cssTag}_id`"
                    data-bs-toggle="pill"
                    :data-bs-target="`#${item.cssTag}_content`"
                    type="button"
                    role="tab"
                    :aria-controls="`${item.cssTag}_content`"
                    :aria-selected="item.ST_ID === currentType"
                    :disabled="loading"
                    @click="loadNews(item.ST_ID)"
                    :title="item.ST_Name_1000"
                    tabindex="0"
                >
                    {{ item.ST_Name_1000 }}
                </button>
            </li>
        </ul>

        <div class="row parttimejob" v-show="currentType === '201108010001'">
            <div class="col-lg-6 col-md-6 col-8">
                <img :src="`${baseUrl}assets/images/公司求才.png`" alt="" />公司求才登記表
            </div>
            <div class="col-lg-6 col-md-6 col-4">
                <div class="download">
                    <a
                        href="//campus2.sce.pccu.edu.tw/104/doc/公司求才登記表.doc"
                        alt="公司求才登記表"
                        tabindex="0"
                        v-text="'下載'"
                    ></a>
                </div>
            </div>
        </div>

        <div class="tab-content" id="pills-tabContent" v-if="newsType.length > 0">
            <ul
                class="mt-3"
                :style="`min-height:300px; height:${configs.height}; overflow-y:${configs.overflow};`"
                v-infinite-scroll="getNewsList"
                :infinite-scroll-distance="1"
                :infinite-scroll-disabled="scrollLoad"
                v-loading.body.lock="loading"
                element-loading-text="加載中"
                element-loading-background="rgba(255, 255, 255, 0.5)"
                element-loading-custom-class="loading-mask"
            >
                <li v-for="item in datas" :key="item.date">
                    <div class="row">
                        <div class="col-lg-1 col-md-1 col-1 pt-04">
                            <!-- PC style -->
                            <span class="list_date pc-style" v-html="item.date"></span>
                            <!-- mobile style -->
                            <!-- <span class="list_date mobile-style"
                                  v-html="item.date.substr(5)"></span> -->
                            <span class="list_date mobile-style" v-html="item.date.substr(0, 5)"></span>
                            <br class="mobile-style" />
                            <span class="list_date mobile-style" v-html="item.date.substr(5)"></span>
                        </div>
                        <div class="col-lg-11 col-md-11 col-11 list_content">
                            <div class="list_line" v-for="news in item.news" :key="news.BoardID">
                                <div
                                    class="list_inner"
                                    @click="
                                        viewContent(news.BlockID, news.stid, news.BoardID, news.BoardCount, news.TitleC)
                                    "
                                    :title="news.TitleC"
                                    tabindex="0"
                                    role="link"
                                >
                                    <!-- PC style -->
                                    <div class="list_right pc-style">
                                        {{ news.Supplier }}
                                    </div>

                                    <div class="news-title">
                                        <i
                                            v-if="currentType === ''"
                                            :class="`fa-solid fa-square-full fa-sm
                                                ${
                                                    news.stid === '201108010001'
                                                        ? 'square_08'
                                                        : news.stid === '201106160007'
                                                        ? 'square_09'
                                                        : news.stid === '201106160006'
                                                        ? 'square_07'
                                                        : news.stid === '201106160005'
                                                        ? 'square_06'
                                                        : news.stid === '201106160004'
                                                        ? 'square_05'
                                                        : news.stid === '201106160003'
                                                        ? 'square_04'
                                                        : news.stid === '201106160002'
                                                        ? 'square_03'
                                                        : news.stid === '201106160001'
                                                        ? 'square_02'
                                                        : 'square_01'
                                                }`"
                                        ></i>
                                        <i
                                            v-else
                                            :class="`fa-solid fa-square-full fa-sm
                                                ${
                                                    currentType === '201108010001'
                                                        ? 'square_08'
                                                        : currentType === '201106160007'
                                                        ? 'square_09'
                                                        : currentType === '201106160006'
                                                        ? 'square_07'
                                                        : currentType === '201106160005'
                                                        ? 'square_06'
                                                        : currentType === '201106160004'
                                                        ? 'square_05'
                                                        : currentType === '201106160003'
                                                        ? 'square_04'
                                                        : currentType === '201106160002'
                                                        ? 'square_03'
                                                        : currentType === '201106160001'
                                                        ? 'square_02'
                                                        : 'square_01'
                                                }`"
                                        ></i
                                        >&nbsp;<span v-html="news.TitleC"></span>&nbsp;<img
                                            :src="`${baseUrl}assets/images/attached.png`"
                                            alt=""
                                            class="download_icon"
                                            v-if="news.haveFile"
                                        />
                                    </div>

                                    <!-- mobile style -->
                                    <div class="list_right mobile-style">
                                        {{ news.Supplier }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="row">
            <!-- 搜尋 -->
            <div class="col-lg-6 col-md-6 col-6">
                <el-tooltip
                    content="點擊「放大鏡」圖示以搜尋所有公告"
                    effect="dark"
                    placement="right-end"
                    :open-delay="500"
                >
                    <div class="search-box mt-3">
                        <button class="btn-search" @click="doSearch" title="送出搜尋" tabindex="0">
                            <i class="fas fa-search"></i>送出搜尋
                        </button>

                        <input
                            ref="keywordSearch"
                            type="text"
                            class="input-search input-search-click"
                            v-model.trim="keyword"
                            :disabled="loading"
                            @blur="doSearch"
                            @keyup.enter="doSearch"
                            placeholder="搜尋"
                            title="搜尋"
                            tabindex="0"
                        />
                    </div>
                </el-tooltip>
            </div>

            <!-- 更多公告 -->
            <div v-if="configs.showMore" class="col-lg-6 col-md-6 col-6">
                <div class="more_info mt-3">
                    <a @click="$router.push('/board')" title="更多公告" tabindex="0">更多公告</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import XEUtils from 'xe-utils'
import { getBlockSubType, getNewsList } from '@/api/campus'

export default {
    name: 'news',

    props: {
        height: {
            type: [String, Number],
            default: 180,
        },

        overflow: {
            type: String,
            default: 'overlay',
        },

        pageSize: {
            type: [String, Number],
            default: 10,
        },

        pageLimit: {
            type: [String, Number],
            default: 0,
        },

        showMore: {
            type: Boolean,
            default: false,
        },
    },

    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            configs: {
                height: XEUtils.isNumber(this.height) ? `${this.height}px` : this.height,
                overflow: this.overflow,
                pageLimit: XEUtils.isNumber(this.pageLimit) ? this.pageLimit : XEUtils.toNumber(this.pageLimit),
                showMore: this.showMore,
            },
            newsType: [],
            currentType:
                !this.$route.query || !this.$route.query.stid ? this.$store.getters.stid : this.$route.query.stid,
            newsLs: [],
            newsPage: 1,
            newsPageSize: XEUtils.isNumber(this.pageSize) ? this.pageSize : XEUtils.toNumber(this.pageSize),
            newsTotalPage: 1,
            keyword: this.$store.getters.keyword,
            loading: false,
            scrollLoad: true,
            alreadyCall: null,
        }
    },

    created: function () {
        this.getNewsType().then(() => {
            this.scrollLoad = false
        })
    },

    computed: {
        /* noMore() {
            //當前頁和,和返回的總頁面對比
            return this.newsPage > this.newsTotalPage
        },
        disabled() {
            //當兩個都爲真的時候不加載,頁面滾動失效
            return this.loading || this.noMore
        }, */
        datas() {
            let vm = this
            if (XEUtils.isEmpty(vm.keyword)) {
                return vm.newsLs
            } else {
                let filterName = XEUtils.toString(vm.keyword).trim().toLowerCase()
                if (filterName) {
                    let filterRE = new RegExp(filterName, 'gi')
                    let searchProps = ['TitleC']
                    let rest = XEUtils.clone(vm.newsLs, true)
                    XEUtils.arrayEach(rest, item => {
                        item.news = item.news.filter(item =>
                            searchProps.some(key => XEUtils.toString(item[key]).toLowerCase().indexOf(filterName) > -1)
                        )
                    })

                    XEUtils.arrayEach(rest, item => {
                        item.news = item.news.map(row => {
                            let item2 = Object.assign({}, row)
                            searchProps.forEach(key => {
                                item2[key] = XEUtils.toString(item2[key]).replace(
                                    filterRE,
                                    match => `<span class="keyword-lighten">${match}</span>`
                                )
                            })
                            return item2
                        })
                    })
                    return rest
                }
                return vm.newsLs
            }
        },
    },

    mounted: function () {
        $('.btn-search').on('click', function () {
            $('.input-search').addClass('input-search-click')
        })
    },

    methods: {
        async getNewsType() {
            const vm = this
            await getBlockSubType().then(res => {
                vm.newsType = res.Items
                vm.newsType.unshift({
                    ST_ID: '',
                    ST_Name_1000: '全部',
                })
                XEUtils.arrayEach(vm.newsType, row => {
                    switch (row.ST_ID) {
                        case '201106160001': //考試
                            row['cssTag'] = 'tags_02'
                            break
                        case '201106160002': //選課
                            row['cssTag'] = 'tags_03'
                            break
                        case '201106160003': //獎助學金
                            row['cssTag'] = 'tags_04'
                            break
                        case '201106160004': //繳費
                            row['cssTag'] = 'tags_05'
                            break
                        case '201106160005': //語文修習
                            row['cssTag'] = 'tags_06'
                            break
                        case '201106160006': //活動訊息
                            row['cssTag'] = 'tags_07'
                            break
                        case '201106160007': //其他
                            row['cssTag'] = 'tags_09'
                            break
                        case '201108010001': //人力媒合
                            row['cssTag'] = 'tags_08'
                            break
                        case '':
                            row['cssTag'] = 'tags_01'
                            break
                    }
                })
            })
        },

        async getNewsList() {
            const vm = this
            const alreadyCall = vm.alreadyCall
            vm.scrollLoad = true
            if (vm.newsPage <= vm.newsTotalPage && alreadyCall === null && vm.scrollLoad) {
                vm.alreadyCall = vm.newsPage
                vm.loading = true
                let params = {
                    blockID: '1000310006000042,1000310006000004',
                    widgetnum: vm.newsPageSize,
                    page: vm.newsPage,
                }
                if (vm.currentType != '') params.stid = vm.currentType
                if (vm.keyword != '') params.query = vm.keyword
                await getNewsList(params)
                    .then(res => {
                        if (res.Code === 1) {
                            // vm.newsLs = res.Items
                            if (vm.configs.pageLimit !== 0) {
                                vm.newsTotalPage = vm.configs.pageLimit
                            } else {
                                vm.newsTotalPage = Math.ceil(res.TotalResult / vm.newsPageSize)
                            }

                            //Group By StartDate
                            let dates = XEUtils.uniq(XEUtils.map(res.Items, item => item.StartDate))
                            XEUtils.arrayEach(dates, date => {
                                vm.newsLs.push({
                                    date,
                                    news: XEUtils.filter(res.Items, item => item.StartDate === date),
                                })
                            })
                            // console.log('News', vm.newsLs)
                            // console.log('NewsPage:', `${vm.newsPage} / ${vm.newsTotalPage}`)
                            // vm.$message({
                            //     message: res.Msg,
                            //     type: 'success',
                            // })
                        }
                        vm.alreadyCall = null
                        vm.loading = false
                    })
                    .finally(() => {
                        vm.newsPage++
                        vm.scrollLoad = false
                    })
            } else {
                if (vm.configs.pageLimit === 0)
                    vm.$message({
                        message: '已經沒有更多消息了',
                        type: 'warning',
                    })
            }
        },

        loadNews(active) {
            const vm = this
            if (!vm.loading) {
                if (active != 'query') vm.currentType = active
                vm.$store.dispatch('app/cacheKeyword', vm.keyword)
                vm.$store.dispatch('app/cacheSTID', vm.currentType)
                vm.newsLs = []
                vm.newsPage = 1
                vm.newsTotalPage = 1

                // 防止無限滾動組件觸發兩次問題
                // vm.scrollLoad = true
                window.setTimeout(() => {
                    vm.getNewsList().then(() => {
                        // vm.scrollLoad = false
                    })
                }, 200)
            }
        },

        viewContent(blockID, stID, boardID, boardCount, title) {
            this.$store.dispatch('app/cachePNTitle', title)
            this.$router.push(
                `/board/postnews?QueryBoardId=${boardID}&BoardCount=${boardCount}&blockid=${blockID}&stid=${stID}`
            )
        },

        doSearch() {
            // this.$refs.keywordSearch.classList.add('input-search-click')
            if (this.$refs.keywordSearch.className.indexOf('input-search-click') > 0) this.loadNews('query')
        },
    },
}
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
    width: 7px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
    border: 0px solid slategrey;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}

::v-deep .keyword-lighten {
    color: black;
    background-color: yellow;
}

.mt-3 {
    padding-right: 7px;
    overflow-x: hidden;
}

.tab-content > .tab-pane {
    display: block;
}

.loading {
    min-height: 100px;
}

.news-title {
    width: calc(100% - 100px);
}
.pc-style {
    display: revert;
}
.mobile-style {
    display: none;
}
@media screen and (max-width: 993px) {
    .news-title {
        width: 100%;
    }
    .list_content {
        padding-left: 30px;
    }
    .pc-style {
        display: none;
    }
    .mobile-style {
        display: revert;
        float: none;
        width: 100%;
        margin-left: auto;
    }
    .mobile-style + br {
        display: none;
    }
}
@media screen and (max-width: 767.9px) and (min-width: 295px) {
    .mobile-style + br {
        display: revert;
    }
}
.parttimejob {
    background-color: #f0d0db;
    height: 50px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #b0154c;

    img {
        height: 44px;
        margin: 3px 0;
        padding-right: 10px;
    }

    .download {
        padding-right: 7px;
        overflow-x: hidden;
        margin-top: 9px;
        text-align: right;

        a {
            background-color: #b0154c;
            border-radius: 15px;
            padding: 2px 12px;
            color: #fff;
            font-size: 0.875rem;
        }
    }
}
.nav-link:focus {
    border-width: 0.3em;
}
.nav-link.active:focus {
    box-shadow: 0 0 0 0.15em #fff inset;
}
</style>
